import {
  BagCheckoutContainer,
  BagContentContainer,
  BagDynamicModal,
  BagScrollView,
} from './Containers';
import { BagPaymentHeaderContainer } from './Containers/BagPaymentHeaderContainer';
import {
  BagCheckoutCta,
  BagContinueToBagCta,
  BagContinueToCheckoutCta,
  BagCreditToggle,
  BagFloatingCtas,
  BagViewMenuCta,
} from './Ctas';
import { BagUtensilsCta } from './Ctas/BagUtensilsCta';
import { BagDisclaimers, BagDiscount, BagFooter, BagSubtotal } from './Footer';
import { BagGiftCardForm } from './GiftCard';
import {
  BagAnimatedDialogTitle,
  BagChannelHeader,
  BagHeaderContainer,
  BagLocationFromConnector,
  BagLocationHeader,
  BagLocationToConnector,
  BagTimeConnector,
  BagTimeHeader,
} from './Header';
import { BagHeaderLine } from './Header/BagHeaderLine';
import { BagLedger } from './Ledger';
import { BagPaymentMethodForm } from './PaymentMethodForm';
import {
  BagDropoffLocationPicker,
  BagPaymentMethodPicker,
  BagTimePicker,
} from './Pickers';
import {
  BagPromoField,
  BagPromoRewardsContainer,
  BagReward,
  BagRewardsEmptyState,
  BagRewardsRail,
} from './PromoRewards';
import { BagSelectedPaymentMethod } from './SelectedPaymentMethod';
import { BagEmptyState, BagLoadingState } from './States';
import { BagStripe, BagStripeOpacityAnimation } from './Stripe';
import {
  BagFutureDateWarning,
  BagRewardWarning,
  BagWarningModal,
} from './Warnings';

export { sumLedgerTotal } from './Ledger';

export const Bag = {
  //
  // ─── Containers ───────────────────────────────────────────────────────────

  DynamicModal: BagDynamicModal,
  ScrollView: BagScrollView,
  ContentContainer: BagContentContainer,
  CheckoutContainer: BagCheckoutContainer,
  PaymentHeaderContainer: BagPaymentHeaderContainer,

  // ─── States ───────────────────────────────────────────────────────────────

  LoadingState: BagLoadingState,
  EmptyState: BagEmptyState,

  // ─── Warnings ─────────────────────────────────────────────────────────────

  WarningModal: BagWarningModal,
  FutureDateWarning: BagFutureDateWarning,
  RewardWarning: BagRewardWarning,

  // ─── Pickers ──────────────────────────────────────────────────────────────

  TimePicker: BagTimePicker,
  DropoffLocationPicker: BagDropoffLocationPicker,
  PaymentMethodPicker: BagPaymentMethodPicker,

  // ─── Header ───────────────────────────────────────────────────────────────

  AnimatedDialogTitle: BagAnimatedDialogTitle,
  HeaderLine: BagHeaderLine,
  ChannelHeader: BagChannelHeader,
  HeaderContainer: BagHeaderContainer,
  LocationFromConnector: BagLocationFromConnector,
  LocationHeader: BagLocationHeader,
  LocationToConnector: BagLocationToConnector,
  TimeConnector: BagTimeConnector,
  TimeHeader: BagTimeHeader,

  // ─── Promo Code Rewards ───────────────────────────────────────────────────

  PromoRewardsContainer: BagPromoRewardsContainer,
  RewardsRail: BagRewardsRail,
  Reward: BagReward,
  RewardsEmptyState: BagRewardsEmptyState,
  PromoField: BagPromoField,

  // ─── Payment method ───────────────────────────────────────────────────────

  PaymentMethodForm: BagPaymentMethodForm,

  // ─── Giftcard ─────────────────────────────────────────────────────────────

  GiftCardForm: BagGiftCardForm,

  // ─── Footer ──────────────────────────────────────────────────────────

  Footer: BagFooter,
  Subtotal: BagSubtotal,
  Discount: BagDiscount,
  Disclaimers: BagDisclaimers,

  // ─── Checkout ─────────────────────────────────────────────────────────────

  SelectedPaymentMethod: BagSelectedPaymentMethod,
  CreditToggle: BagCreditToggle,
  Ledger: BagLedger,
  Stripe: BagStripe,
  StripeOpacityAnimation: BagStripeOpacityAnimation,

  // ─── CTAs ─────────────────────────────────────────────────────────────────

  ViewMenuCta: BagViewMenuCta,
  UtensilsCta: BagUtensilsCta,
  ContinueToBagCta: BagContinueToBagCta,
  ContinueToCheckoutCta: BagContinueToCheckoutCta,
  FloatingCtas: BagFloatingCtas,
  CheckoutCta: BagCheckoutCta,
};
